// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import axios from 'axios';
import App from './App';
import i18n from './i18n';
import CountryFlag from 'vue-country-flag';

import Vuetify from 'vuetify';

import 'vuetify/dist/vuetify.min.css';

import './main.css';

Vue.use(axios);

Vue.use(Vuetify);
Vue.prototype.$axios = axios;
Vue.config.productionTip = false;

Vue.component('country-flag', CountryFlag);

/* eslint-disable no-new */
new Vue({
  el: '#app',
  i18n,
  components: { App },
  template: '<App/>',
});



// WEBPACK FOOTER //
// ./src/main.js